import React from 'react';
import { Link } from "react-router-dom";
import './not_Found.css'

const Not_Found = () => {
  return (
    <div id='notfound'>
        <div className='notfound'>
            <div className='notfound-404'>
                <h1>404</h1>
            </div>
            <h2>We are Sorry(-_-) Page Not Found! </h2>
            <p className='mb-5'>
                The page you are looking for might have been removed, had its name changed or is temporarily unavailable.
            </p>
            <Link to='/dashboard'>Back to Homepage</Link>
        </div>

    </div>
  )
}

export default Not_Found;